<template>
  <div v-if="isLoaded">
    <transition>
      <div class="row" v-if="unitsErrorMessage">
        <div class="col-12">
          <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
            {{ unitsErrorMessage }}
          </div>
        </div>
      </div>
    </transition>

    <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
      <div class="col text-right" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
      <div class="col-auto text-right">
        <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
      </div>
    </div>

    <form @submit.prevent="submitForm" novalidate coaching-id="" operation-type="" protocol-id="" submit-form>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
          <Datepicker
              :disabled="isBilled || isCoachBilled"
              v-model="formData.termin"
              :required="true"
              label="Termin"
              position="down"
              :validation="v$.termin"
              :messages="v$.termin.required.$message"/>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12  ">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :disabled="isBilled || isCoachBilled"
                  :key="startTimeKey"
                  v-model="formData.startTime"
                  :required="true"
                  :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                  label="Startzeit"/>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :disabled="isBilled || isCoachBilled"
                  :key="endTimeKey"
                  v-model="formData.endTime"
                  :required="true"
                  :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                  label="Endzeit"/>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue v-model="formData.presence"
                     :disabled="isBilled || isCoachBilled"
                     :options="presenceDropdown"
                     :required="true"
                     label="Anwesenheit"
                     placeholder="Wählen Sie Anwesenheit"
                     :validation="v$.presence"
                     :messages="v$.presence.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseCheckbox
              :disabled="isBilled || isCoachBilled"
              v-model="formData.overwrite"
              label="Überschreiben"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 mt-3 mt-sm-0">
          <BaseNumber
              v-model="formData.units"
              label="Einheiten"
              disabled="disabled"/>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <SelectVue v-model="formData.coachType"
                     :disabled="isBilled || isCoachBilled"
                     :options="coachTypeDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Coachart"
                     placeholder="Wählen Sie Coachart"
                     :validation="v$.coachType"
                     :messages="v$.coachType.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                :disabled="isBilled || isCoachBilled || isDigitalSignature"
                v-model="formData.signature"
                label="Unterschrift"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class="mt-4">
            <BaseCheckbox
                :disabled="isBilled || isCoachBilled"
                v-model="formData.billed"
                label="Abgerechnet"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class=" mt-4">
            <BaseCheckbox
                :disabled="isBilled || isCoachBilled"
                v-model="formData.paid"
                label="Bezahlt"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                :disabled="isBilled || isCoachBilled"
                v-model="formData.homeVisit"
                label="Hausbesuch"
                :labelPosition="'right'"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 mt-3 mt-sm-0"
             v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_ACCOUNTANT'">
          <SelectVue v-model="formData.coachId"
                     :disabled="isCoachBilled"
                     :options="coachDropdown"
                     :is-clear="true"
                     label="Coach"
                     placeholder="Trainer auswählen"/>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <h6>Einschränkung</h6>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <BaseInput v-model="formData.meetingTopic"
                     label="Sitzungsthema"
                     :required="true"
                     :validation="v$.meetingTopic"
                     :messages="v$.meetingTopic.required.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <TextEditor
              v-model="formData.description"
              @update:model-value="formData.description = $event"
              :inputStyle="{ height: '200px' }"
              label="Beschreibung"/>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12 d-flex justify-content-end">
          <BaseCheckbox
              v-model="formData.geva"
              label="Geva-Potentialanalyse"
              :labelPosition="'right'"
              :disabled="isBilled || isCoachBilled"/>
        </div>
      </div>

      <div v-if="!unitsErrorMessage" class="d-flex justify-content-center w-100 mt-2">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import dropdownService from '@/api/Dropdown';
import portalGroupCoachingService from '@/api/Portal/GroupCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {addDeletedCoachToDropdown} from '@/shared/portal/commonFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import BaseToggle from "@/components/base/BaseToggle.vue";
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const coachDropdown = ref([]);
const presenceDropdown = ref([]);
const coachTypeDropdown = ref([]);
const portalCoachTypeEnums = ref([]);
const portalGroupCoachingCoachTypeEnums = ref([]);
const unitsErrorMessage = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);
const updateAsAdmin = ref(false) // Need this for update as admin logic
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic

const props = defineProps({
  coachingId: {
    type: Number,
    required: true,
  },
  protocolId: {
    type: [Number, String],
    required: true,
  },
  operationType: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  isDigitalSignature: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const coachingId = toRefs(props)['coachingId'];
const protocolId = toRefs(props)['protocolId'];
const operationType = toRefs(props)['operationType'];

const formData = ref({
  coachingId: '',
  operationType: '',
  termin: '',
  startTime: '00:00',
  endTime: '00:00',
  presence: '',
  coachType: '',
  overwrite: false,
  units: 0,
  signature: false,
  billed: false,
  paid: false,
  homeVisit: false,
  coachId: null,
  geva: false,
  meetingTopic: '',
  description: '',
});

const originalFormData = ref({});
// This key will force the Timepicker to re-create when changed
const startTimeKey = ref(formData.value.startTime);
const endTimeKey = ref(formData.value.endTime);

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  coachType: requiredRule(t),
  units: requiredRule(t),
  meetingTopic: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId.value;
    formData.value.operationType = operationType.value;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer

    if (props.protocolId) {
      if (updateAsAdmin.value) {
        await portalGroupCoachingService.updateProtocolAsAdmin(
            formData.value,
            +protocolId.value
        );
      } else {
        await portalGroupCoachingService.updateProtocol(
            formData.value,
            +protocolId.value
        );
      }

    } else {
      await portalGroupCoachingService.postProtocol(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getProtocolData(protocolId) {
  try {
    const {data} = await portalGroupCoachingService.getProtocol(protocolId.value);
    const coachId = data.data?.coach?.id;

    isBilled.value = data.data.invoiced;
    isCoachBilled.value = data.data.coachInvoiced;

    // Save original values
    originalIsBilled.value = data.data.invoiced;
    originalIsCoachBilled.value = data.data.coachInvoiced;

    addDeletedCoachToDropdown(data.data?.coach, coachDropdown);

    formData.value = {
      ...data.data,
      coachId: coachId,
    };

    // store original as a deep copy !!!
    originalFormData.value = JSON.parse(JSON.stringify(formData.value));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getAssignedCoachesForDropdown(coachingId) {
  try {
    CloseToast();
    const {data} = await dropdownService.getGroupCoachingAssignedCoaches(+coachingId);
    coachDropdown.value = data.data.map(item => ({
      label: `${item.firstName}` + ' ' + `${item.lastName}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

const calculateTimeDifference = () => {
  if (formData.value.startTime && formData.value.endTime) {
    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const diffMinutes = endTotalMinutes - startTotalMinutes;
    let units = (diffMinutes / 45).toPrecision(3).substring(0, 4);
    let unitDuration = 45;

    onChangeUnits(units);

    // Check a presence type
    if ((formData.value.presence)) {
      if (formData.value.presence === 'anwesend') {
        units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
      } else {
        units = 1;
      }
    }

    // If presenceType is selected and overview is true, calculate units
    if (formData.value.overwrite === true) {
      units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
    }

    formData.value.units = Number(units).toFixed(2);
  } else {
    formData.value.units = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Einheiten müssen runde Zahlen sein, die größer als 0 sind.';
  } else {
    unitsErrorMessage.value = '';
  }
}

watch(
    () => [
      formData.value.startTime,
      formData.value.endTime,
      formData.value.presence,
      formData.value.overwrite,
    ],
    calculateTimeDifference,
);

async function getEnumsDropdown() {
  presenceDropdown.value = getEnums?.value?.presenceTypes || [];
  portalCoachTypeEnums.value = getEnums?.value?.portalCoachTypes || [];
  portalGroupCoachingCoachTypeEnums.value = getEnums?.value?.portalGroupCoachingCoachTypes || [];
}

function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;
  } else {
    // restore form data from original snapshot
    formData.value = JSON.parse(JSON.stringify(originalFormData.value));

    formData.value.startTime = originalFormData.value.startTime;
    startTimeKey.value = originalFormData.value.startTime + '_' + Date.now(); // Change the key to force re-render

    formData.value.endTime = originalFormData.value.endTime;
    endTimeKey.value = originalFormData.value.endTime + '_' + Date.now(); // Change the key to force re-render

    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;
  }
}

const showUpdateAsAdminButton = computed(() =>
    (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    (originalIsBilled.value || originalIsCoachBilled.value)
);

onMounted(async () => {
  await Promise.all([
    getAssignedCoachesForDropdown(+coachingId.value),
    getEnumsDropdown(),
  ]);

  if (operationType.value === 'ib') {
    coachTypeDropdown.value = portalGroupCoachingCoachTypeEnums.value;
  } else {
    coachTypeDropdown.value = portalCoachTypeEnums.value;
  }

  if (protocolId.value) {
    await getProtocolData(protocolId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>